import { render } from "./resetPassword.vue?vue&type=template&id=a091a11a&scoped=true"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"

import "./resetPassword.vue?vue&type=style&index=0&id=a091a11a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a091a11a"

export default script